import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule } from '@angular/forms';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { LandingComponent } from "./landing/landing.component";
import { LandingLeaderComponent } from "./landingLeaderGo/landing.component";
import { LandingActionGoComponent } from "./landingActionGo/landing.component";
import { LandingFocusComponent } from "./landingFocus/landing.component";
import { LandingN35ComponentV2 } from "./landing-n35V2/landing-n35V2.component";
// import { LandingN35Component } from "./landing-n35/landing-n35.component";
import { LandingculturetrComponent } from './landingculturetr/landingculturetr.component';
import { LandingculturemxComponent } from './landingculturemx/landingculturemx.component';
import { LandingculturechComponent } from './landingculturech/landingculturech.component';
import { Landingculture_espComponent } from './ladingesp/landingculture_esp.component';
import { TableLeaderGoComponent } from 'app/main/pagina/productos/leaderGo/table-leader-go/table-leader-go.component';
import { AdminPulsecheckComponent } from './landing/admin-pulsecheck/admin-pulsecheck.component';
import { DialogModalFocus } from './landing/admin-pulsecheck/admin-pulsecheck.component';
import { ModalAgregarEncComponent } from './landing/admin-pulsecheck/modal-agregar-enc/modal-agregar-enc.component';

import { LandingCloudComponent } from "./landingCloud/landingCloud.component";
import { LeaderGoUserComponent } from 'app/main/pagina/productos/leader-go-user/leader-go-user.component';
const rutas: Routes = [
  // Landing certificar
  {
      path     : 'certify',
      component: LandingComponent,
      data : {producto : '1'},
      canActivate: [AuthGuard]
  },
  // Landing certificar v2
  {
      path     : 'certify_t1',
      component: LandingComponent,
      data : {producto : 'c1'},
      canActivate: [AuthGuard]
  },
  // Landing certificar v3
  {
      path     : 'certify_t2',
      component: LandingComponent,
      data : {producto : 'c2'},
      canActivate: [AuthGuard]
  },
  // Landing certificar v3 (otro 3 :v)
  {
      path     : 'certify_t3',
      component: LandingComponent,
      data : {producto : 'c3'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'certify_t4',
      component: LandingComponent,
      data : {producto : 'c4Plata'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'certify_t6',
      component: LandingComponent,
      data : {producto : 'c6'},
      canActivate: [AuthGuard]
  },
  // Landing medir
  {
      path     : 'measurement',
      component: LandingComponent,
      data : {producto : '2'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t1',
      component: LandingComponent,
      data : {producto : 'm1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t2',
      component: LandingComponent,
      data : {producto : 'm2'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t3',
      component: LandingComponent,
      data : {producto : 'm3'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t4',
      component: LandingComponent,
      data : {producto : 'm4'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t5',
      component: LandingComponent,
      data : {producto : 'm5'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t6',
      component: LandingComponent,
      data : {producto : 'm6'},
      canActivate: [AuthGuard]
  },
  // medir 3.0
  {
      path     : 'measurement_t7',
      component: LandingComponent,
      data : {producto : 'm7'},
      canActivate: [AuthGuard]
  },
  // Landing Pulse
  {
      path     : 'pulse',
      component: LandingComponent,
      data : {producto : '3'},
      canActivate: [AuthGuard]
  },
  {
    path     : 'pulse/adminpulsecheck',
    component: AdminPulsecheckComponent,
  },
  // pulse 3.0
  {
      path     : 'pulse_t1',
      component: LandingComponent,
      data : {producto : 'p1'},
      canActivate: [AuthGuard]
  },
  {
    path     : 'pulse_t1/adminpulsecheck',
    component: AdminPulsecheckComponent,
  },
  // Landing Focus
  {
      path     : 'focus',
      component: LandingFocusComponent,
      data : {producto : '4'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'focus_t1',
      component: LandingComponent,
      data : {producto : 'f1'},
      canActivate: [AuthGuard]
  },
  {
    path     : 'focus_t1/adminpulsecheck',
    component: AdminPulsecheckComponent,
  },
  // {
  //     path     : 'NOM35',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35'},
  //     canActivate: [AuthGuard]
  //
  // },{
  //     path     : 'NOM35-ENC',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35-ENC'},
  //     canActivate: [AuthGuard]
  //
  // },{
  //     path     : 'NOM35-EXP',
  //     component: LandingN35Component,
  //     data : {infoLanding35 : 'NOM35-EXP'},
  //     canActivate: [AuthGuard]
  // }
  {
      path     : 'NOM35',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35'},
      canActivate: [AuthGuard]

  },{
      path     : 'NOM35-ENC',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35-ENC'},
      canActivate: [AuthGuard]

  },{
      path     : 'NOM35-EXP',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35-EXP'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'NOM35-BETTHER',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35BETHE'},
      canActivate: [AuthGuard]

  },
  {
      path     : 'NOM35-PLATA',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35PLA'},
      canActivate: [AuthGuard]

  },
  {
      path     : 'NOM35-v3',
      component: LandingN35ComponentV2,
      data : {infoLanding35 : 'NOM35V3'},
      canActivate: [AuthGuard]

  }
    //Turquía
  ,{
        path     : 'culture_tr1',
        component: LandingculturetrComponent,
        data : {producto : 'culture1'},
        canActivate: [AuthGuard]
  },{
        path     : 'culture_tr2',
        component: LandingculturetrComponent,
        data : {producto : 'culture2'},
        canActivate: [AuthGuard]
  },{
        path     : 'culture_tr3',
        component: LandingculturetrComponent,
        data : {producto : 'culture3'},
        canActivate: [AuthGuard]
  },{
        path     : 'culture_Ozel_tr1',
        component: LandingculturetrComponent,
        data : {producto : 'cultureOzel'},
        canActivate: [AuthGuard]
  },

  //MEXICO CA
  {
        path     : 'culture_MX1',
        component: LandingculturemxComponent,
        data : {producto : 'culture5.0'},
        canActivate: [AuthGuard]
  },{
        path     : 'culture_MX2',
        component: LandingculturemxComponent,
        data : {producto : 'cultureCR'},
        canActivate: [AuthGuard]
  },{
        path     : 'culture_MX3',
        component: LandingculturemxComponent,
        data : {producto : 'cultureGoFlow'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX4',
        component: LandingculturemxComponent,
        data : {producto : 'culturePanama'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX5',
        component: LandingculturemxComponent,
        data : {producto : 'cultureSP'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX6',
        component: LandingculturemxComponent,
        data : {producto : 'cultureMX_2021'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX7',
        component: LandingculturemxComponent,
        data : {producto : 'cultureCR_2021'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX8',
        component: LandingculturemxComponent,
        data : {producto : 'culturePA_2021'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX9',
        component: LandingculturemxComponent,
        data : {producto : 'GoFlow_1_2021'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX10',
        component: LandingculturemxComponent,
        data : {producto : 'GoFlow_2_2021'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX11',
        component: LandingculturemxComponent,
        data : {producto : 'SP_2022'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX12',
        component: LandingculturemxComponent,
        data : {producto : 'GoFlow_2_2022'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX13',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Estandar_1'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX14',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_CA&C'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX15',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Brief_(certificar)_2022'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX16',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Audit_(certificar,rkg.)'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX17',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Audit_(certificar,rkg.yadic.)'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX18',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Audit_(certificar,rkg.yadic.)_2024'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX19',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Brief_(certificar)_2024'},
        canActivate: [AuthGuard]
  },
  {
        path     : 'culture_MX20',
        component: LandingculturemxComponent,
        data : {producto : 'Culture_Audit_(certificar_y_ranking)_2024'},
        canActivate: [AuthGuard]
  },

  //CHINA
  {
    path     : 'culture_ch1',
    component: LandingculturechComponent,
    data : {producto : 'culture_ch1'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_ch2',
    component: LandingculturechComponent,
    data : {producto : 'culture_ch2'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_ch3',
    component: LandingculturechComponent,
    data : {producto : 'culture_ch3'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_ch4',
    component: LandingculturechComponent,
    data : {producto : 'culture_ch4'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_ch5',
    component: LandingculturechComponent,
    data : {producto : 'culture_ch5'},
    canActivate: [AuthGuard]
  },

  //España

  {
    path     : 'culture_esp1',
    component: Landingculture_espComponent,
    data : {producto : 'culture_esp1'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_esp2',
    component: Landingculture_espComponent,
    data : {producto : 'culture_esp2'},
    canActivate: [AuthGuard]
  },{
    path     : 'culture_esp3',
    component: Landingculture_espComponent,
    data : {producto : 'culture_esp3'},
    canActivate: [AuthGuard]
  },
  {
      path     : 'leader_GO®_admin',
      component: LandingLeaderComponent,
      data : {producto : 'L1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'leader_GO®',
      component: LandingLeaderComponent,
      data : {producto : 'LU1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'leader_GO®_User',
      component: LeaderGoUserComponent,
      data : {producto : 'LU1'},
      canActivate: [AuthGuard]
  },
  // ICCA AMCO
  {
      path     : 'icca',
      component: LandingculturemxComponent,
      data : {producto : 'culture_ICCA'},
      canActivate: [AuthGuard]
  },
  // ICCA MEXICO
  {
      path     : 'culture_ICCA',
      component: LandingculturemxComponent,
      data : {producto : 'culture_ICCAMEX'},
      canActivate: [AuthGuard]
  },
  // CULTURE AUDITS CAYC
  {
      path     : 'Culture_Brief',
      component: LandingculturemxComponent,
      data : {producto : 'Culture_Brief'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'Culture_Audit',
      component: LandingculturemxComponent,
      data : {producto : 'Culture_AuditCAYC'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'Culture_Brief_Culture_Audit',
      component: LandingculturemxComponent,
      data : {producto : 'Culture_Brief_Culture_Audit'},
      canActivate: [AuthGuard]
  },
  // ICI AMCO
  {
      path     : 'measurement_t8',
      component: LandingComponent,
      data : {producto : 'm8', tituloAlterno: 'MEDIR_M8'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'measurement_t9',
      component: LandingComponent,
      data : {producto : 'm9', tituloAlterno: 'MEDIR_M9'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'action_GO',
      component: LandingActionGoComponent,
      data : {producto : 'A2'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'actionGo_admin',
      component: LandingActionGoComponent,
      data : {producto : 'A1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'actionGoAdminLider',
      component: LandingActionGoComponent,
      data : {producto : 'ACLIAD'},//action go lider
      canActivate: [AuthGuard]
  },
  {
      path     : 'actionGO',
      component: LandingActionGoComponent,
      data : {producto : 'actionGOLevel13'},//action go lider
      canActivate: [AuthGuard]
  },
  {
      path     : 'actionGoLevel12',
      component: LandingActionGoComponent,
      data : {producto : 'actionGoLevel12'},//action go lider
      canActivate: [AuthGuard]
  },
  {
      path     : 'leader_GO/leaders',
      component: TableLeaderGoComponent,
      canActivate: [AuthGuard]
  },
  {
      path     : 'amco_1',
      component: LandingComponent,
      data : {producto : 'am1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'traba_digno',
      component: LandingComponent,
      data : {producto : 'td1'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'prime_emple',
      component: LandingComponent,
      data : {producto : 'pe1'},
      canActivate: [AuthGuard]
  },

  //GESTOR DE ARCHIVOS
  {
      path     : 'file-server',
      component: LandingCloudComponent,
      data : {producto : 'cloud'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'companies/detail/:id/:idprod/file-server',
      component: LandingCloudComponent,
      data : {producto : 'cloud'},
      canActivate: [AuthGuard, AuthAdminGuard]
  },
  {
      path     : 'companies/detail/:id/:idprod/file-server-private',
      component: LandingCloudComponent,
      data : {producto : 'cloudODS'},
      canActivate: [AuthGuard, AuthAdminGuard]
  },
];

@NgModule({
  declarations: [
    LandingComponent,
    LandingFocusComponent,
    LandingN35ComponentV2,
    // LandingN35Component,
    LandingculturetrComponent,
    LandingculturemxComponent,
    LandingculturechComponent,
    Landingculture_espComponent,
    DialogModalFocus,
    ModalAgregarEncComponent,
    AdminPulsecheckComponent,
    LandingLeaderComponent,
    LandingActionGoComponent,
    LandingCloudComponent,
    LeaderGoUserComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTabsModule,
    MatDividerModule,
    MatExpansionModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule
  ],
  entryComponents: [DialogModalFocus,ModalAgregarEncComponent]
})
export class LandingModule { }
